export default __webpack_public_path__ + "static/media/fontawesome-webfont.af6df524.woff2";